import {
  normalizePosition,
  type Stueckliste,
  type StuecklistePosition,
  type StuecklisteUpsertPayload,
} from "@/lib/stuecklisten";

function snapshotPosition(position: StuecklistePosition) {
  const normalized = normalizePosition(position);
  return {
    position_nr: normalized.position_nr,
    position_kind: normalized.position_kind || "standard",
    anzahl: normalized.anzahl ?? null,
    groesse: normalized.groesse || null,
    beschreibung: normalized.beschreibung || null,
    bemerkung: normalized.bemerkung || null,
    artikel_id: normalized.artikel_id ?? null,
    hero_nr: normalized.hero_nr || null,
    source_type: normalized.source_type || "manual",
    position_status: normalized.position_status || "offen",
    order_line_id: normalized.order_line_id ?? null,
    bestellnummer: normalized.bestellnummer || null,
    zuschnitt_erforderlich: Boolean(normalized.zuschnitt_erforderlich),
    ist_montagematerial: Boolean(normalized.ist_montagematerial),
    schnittwinkel_links: normalized.schnittwinkel_links ?? null,
    schnittwinkel_rechts: normalized.schnittwinkel_rechts ?? null,
    schnittlage: normalized.schnittlage || null,
  };
}

/** Stabiler Snapshot für Dirty-Erkennung (unabhängig von Server-IDs). */
export function buildStuecklisteEditorSnapshot(payload: StuecklisteUpsertPayload): string {
  return JSON.stringify({
    pack: payload.pack || "montage",
    datum: payload.datum || null,
    bauteil: (payload.bauteil || "").trim() || null,
    beschichtung_art: payload.beschichtung_art || null,
    beschichtung_grundiert_ton: payload.beschichtung_grundiert_ton || null,
    beschichtung_finish: payload.beschichtung_finish || null,
    beschichtung_ral: (payload.beschichtung_ral || "").trim() || null,
    notizen: (payload.notizen || "").trim() || null,
    positionen: (payload.positionen || []).map(snapshotPosition),
  });
}

export function buildStuecklisteSnapshotFromItem(item: Stueckliste): string {
  return buildStuecklisteEditorSnapshot({
    pack: item.pack || "montage",
    datum: item.datum || null,
    bauteil: item.bauteil || null,
    beschichtung_art: item.beschichtung_art || null,
    beschichtung_grundiert_ton: item.beschichtung_grundiert_ton || null,
    beschichtung_finish: item.beschichtung_finish || null,
    beschichtung_ral: item.beschichtung_ral || null,
    notizen: item.notizen || null,
    positionen: item.positionen || [],
  });
}

export function editorHasUnsavedStuecklisteChanges(
  payload: StuecklisteUpsertPayload | null,
  savedSnapshot: string | null,
  editable: boolean,
): boolean {
  if (!payload || !editable || !savedSnapshot) return false;
  return buildStuecklisteEditorSnapshot(payload) !== savedSnapshot;
}
